import { cn } from '@wellesley/ui'

type GroupWrapperProps = {
  children: React.ReactNode
  className?: string
}

export const GroupWrapper = ({ children, className }: GroupWrapperProps) => (
  <div
    className={cn(
      'flex flex-col gap-xxs p-none font-semibold text-gray-500',
      className,
    )}
  >
    {children}
  </div>
)
